export default __webpack_public_path__ + "static/img_1_376-088bce4de2c0813345862ad82f4be839.jpg";